import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MultiselectItem, MultiselectSettings, Multiselect } from '../../../core/interfaces/admin.interface';
import { PortalService } from '../../../core/services/portal.service';
import { MULTI_SELECT_SETTING, EMULTI_SELECT_SETTING } from '../../../core/settings/settings.service';

@Component({
  selector: 'sacbo-price-list-select',
  templateUrl: './price-list-select.component.html',
  styleUrls: ['./price-list-select.component.scss']
})
export class PriceListSelectComponent {

  @Input() set preselectedLists(newValue: number[]) {
    this.selectFromId(newValue);
  }

  @Input() singleSelection: boolean = null;

  @Input() disabled: boolean = false;

  @Input() listsSelected: MultiselectItem[] = [];

  @Output() listsSelectedChange = new EventEmitter< MultiselectItem[]>();
  @Output() onSelected = new EventEmitter< MultiselectItem[]>();

  @Input() set idReseller(newValue: number) {
    this.load(newValue);
  }

  protected readonly multiselectSettings = MULTI_SELECT_SETTING;
  protected readonly EMULTI_SELECT_SETTING = EMULTI_SELECT_SETTING;

  get computedSettings(): MultiselectSettings {
    const base = MULTI_SELECT_SETTING[EMULTI_SELECT_SETTING.MULTIPLE_SEARCH];
    if (this.singleSelection != null) {
      return { ...base, singleSelection: this.singleSelection };
    }
    return base;
  }

  list: MultiselectItem[] = [];

  preselectedIds: number[];

  constructor(
    public portalService: PortalService,
  ) {

    this.load();

  }

  onElementSelect(): void {
    this.listsSelectedChange.emit(this.listsSelected);
    this.onSelected.emit(this.listsSelected);
  }

  load(idReseller: number = null) {

    let $api;

    if (idReseller) {
      $api = this.portalService.getMultiselectItemsWithParam(Multiselect.PRICE_LIST_RESELLER_IS_COMPANY, idReseller);
    } else {
      $api = this.portalService.getMultiselectItems(Multiselect.PRICE_LIST_RESELLER_IS_COMPANY);
    }

    $api.subscribe((response) => {

      this.list = response?.data.map(family => {

        return {
          id: family.id,
          itemName: family.name
        } as MultiselectItem

      })

      if (this.preselectedIds?.length && this.listsSelected.length == 0) {
        this.selectFromId(this.preselectedIds);
      }

    },
    (error) => {
      console.log("errore", error);
    });

  }

  selectFromId(ids: number[], withEvent: boolean = true) {

    this.preselectedIds = ids;

    this.listsSelected = this.list.filter(c => ids?.includes(c.id));

    if (withEvent) {
      this.onElementSelect();
    }

  }

}
